import {
  HighPriority,
  List,
  LowPriority,
  MediumPriority,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';

const ticketManagementConstants = {
  MAIN_PAGE: {
    title: 'Support Center',
    subTitle:
      'Submit and manage your technical support tickets for platform issues or queries.',
    welcome:
      'Welcome to the Support Center! Here, you can create tickets to report technical issues, request assistance, or provide feedback. Please select the category that best describes your issue to help us resolve it faster.',
    tabList: [
      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        <List style={{ height: '20px', width: '20px' }} />
        List
      </div>,
    ],
    activeTickets: 'Active Tickets',
    closedTickets: 'Closed Tickets',
    menuOptions: ['View / Edit Details', 'Delete'],
    delete: 'Delete Ticket',
    deleteDesc: 'Are you sure you want to delete this ticket?',
  },
  DETAILS_MODAL: {
    title: 'Create New Ticket',
    issue: 'Issue',
    platform: 'Platform',
    type: 'Type',
    description: 'Description',
    status: 'Status',
    priority: 'Priority',
    dueDate: 'Due Date',
    assignee: 'Assignee',
    cancel: 'Cancel',
    upload: 'Upload',
    uploading: 'Uploading',
    confirm: 'Confirm',
    addTicket: 'Add Ticket',
    descriptionPlaceholder: 'Add a description of the issue',
    platformOptions: [
      'Risk Management',
      'Compliance Assurance',
      'Care Navigation',
      'General',
    ],
    TypeOptions: ['Onboarding', 'User Management', 'Bug', 'Feature', 'Task'],
    priorityOptions: [
      <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
        <LowPriority /> Low
      </div>,
      <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
        <MediumPriority /> Medium
      </div>,
      <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
        <HighPriority /> High
      </div>,
    ],
    priorityValues: ['low', 'medium', 'high'],
    dueDateFormat: 'MMMM D, yyyy',
    ticketId: 'Ticket #',
    save: 'Save',
    details: 'Details',
    statusOptions: ['To Do', 'In Progress', 'In Review', 'Completed'],
    statusValues: ['to_do', 'in_progress', 'in_review', 'completed'],
    edit: 'Edit',
    createdBy: 'Created By',
    comments: 'Comments',
    commentsPlaceholder: 'Type you comment here',
    sending: 'Sending',
    attachments: 'Attachments',
    filterOptions: ['Platform', 'Type', 'Status', 'Priority', 'Assignee'],
    clearFilter: 'Clear All',
    applyFilter: 'Apply Filters',
    showLess: 'Show less',
  },
  avatarColors: [
    '#9f8fef',
    '#c25100',
    '#9DDDEB',
    '#216d6a',
    '#909925',
    '#00a3bf',
    '#00875a',
    '#0052cc',
    '#475CB0',
    '#F2763D',
  ],
};

export default ticketManagementConstants;
